/**
 * 현재 status bar(상단 safe-area) inset 을 px 로 읽는다.
 *
 * CSS 와 같은 단일 출처(`--loc-safe-area-inset-top` — Android SystemBars 주입 변수 →
 * env() 폴백, 안드로이드 인앱브라우저 0 처리까지 반영)를 그대로 쓰기 위해, 크기 0 짜리
 * probe 의 padding-top 으로 변환해 측정한다. 스크롤 오프셋처럼 JS 가 "고정 헤더 높이"를
 * 숫자로 더해야 하는 곳에서 쓴다. SSR/측정 불가 시 0.
 *
 * 레이아웃을 강제하므로 스크롤 핸들러 매 프레임이 아니라 effect 시작/클릭 시점에 읽을 것.
 */
export function readSafeAreaInsetTop(): number {
  if (typeof document === "undefined" || !document.body) return 0;
  const probe = document.createElement("div");
  probe.style.cssText =
    "position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none;" +
    "padding-top:var(--loc-safe-area-inset-top,0px);";
  document.body.appendChild(probe);
  const value = parseFloat(getComputedStyle(probe).paddingTop);
  probe.remove();
  return Number.isFinite(value) ? value : 0;
}
